import { render, staticRenderFns } from "./telaprincipal.vue?vue&type=template&id=2e5666c7&"
import script from "./telaprincipal.vue?vue&type=script&lang=js&"
export * from "./telaprincipal.vue?vue&type=script&lang=js&"
import style0 from "./telaprincipal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports